var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contanier"},[_c('div',{directives:[{name:"drag",rawName:"v-drag"}],ref:"drag",staticClass:"drag-item",attrs:{"draggable":"true"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }